import { useSiteContent } from "@/context/SiteContentContext";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const LINKS = [
  { label: "Privacy Policy", id: "contact" },
  { label: "Terms of Service", id: "contact" },
  { label: "Contact Us", id: "contact" },
];

export const Footer = () => {
  const { t } = useSiteContent();
  return (
    <footer className="border-t border-white/10 py-12 px-6" data-testid="main-footer">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <img src="/logo.png" alt="Logo Iris Photo" className="h-8 w-8 rounded-lg object-cover" />
          <span className="text-white/70 text-sm">Forensic extraction, Iris photo</span>
        </div>
        <div className="flex flex-col sm:items-end gap-3">
          <a
            data-testid="footer-email-link"
            href={`mailto:${t('owner_email')}`}
            className="text-sm text-indigo-400 hover:text-indigo-300 transition-colors"
          >
            {t('owner_email')}
          </a>
          {t('owner_phone') && (
            <a
              data-testid="footer-phone-link"
              href={`tel:${t('owner_phone').replace(/\s/g, "")}`}
              className="text-sm text-indigo-400 hover:text-indigo-300 transition-colors"
            >
              {t('owner_phone')}
            </a>
          )}
          <div className="flex items-center gap-7">
            {LINKS.map((l) => (
              <button
                key={l.label}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => scrollTo(l.id)}
                className="text-sm text-white/55 hover:text-white transition-colors"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-8 text-center sm:text-left text-xs text-white/35">
        © {new Date().getFullYear()} Forensic extraction, Iris photo. All rights reserved.
      </div>
    </footer>
  );
};
